module.exports = __webpack_public_path__ + "static/media/Roose Bolton 2.47170cc9.jpg";